if (!customElements.get('product-request-drawer')) {
  class ProductRequestDrawer extends HTMLElement {
    constructor() {
      super();

      this.init();
    }

    init() {
      // Move to <body> so it stacks above the sticky header regardless of
      // z-index — same technique as sidebar-pickup-availability
      // (assets/pickup-availability.js).
      if (this.parentElement !== document.body) {
        document.body.appendChild(this);
      }

      this.html = document.querySelector('html');
      this.openButtons = document.querySelectorAll(
        `[data-product-request-open][aria-controls="${this.id}"]`
      );
      this.closeButton = this.querySelector('[data-product-request-close]');

      this.openButtons.forEach((button) => {
        button.addEventListener('click', this.openDrawer.bind(this));
      });

      if (this.closeButton) {
        this.closeButton.addEventListener('click', this.closeDrawer.bind(this));
      }

      document.addEventListener('keyup', (event) => {
        if (event.code.toUpperCase() === 'ESCAPE') {
          this.closeDrawer();
        }
      });

      this.addEventListener('click', this.checkIfBodyClicked.bind(this));

      if (this.querySelector('.product-request-drawer__message')) {
        this.openDrawer();
      }
    }

    checkIfBodyClicked(event) {
      if (event.target === this) {
        this.closeDrawer();
      }
    }

    openDrawer() {
      this.setAttribute('data-hidden', 'false');
      this.html.style.overflow = 'hidden';
      this.openButtons.forEach((button) => button.setAttribute('aria-expanded', 'true'));
      this.updateHcaptchaBadgeVisibility();
    }

    closeDrawer() {
      this.setAttribute('data-hidden', 'true');
      this.html.style.overflow = 'initial';
      this.openButtons.forEach((button) => button.setAttribute('aria-expanded', 'false'));
      this.updateHcaptchaBadgeVisibility();
    }

    // Shopify injects an hCaptcha badge for pages using native forms; keep it
    // visible only while a product-request drawer is open.
    updateHcaptchaBadgeVisibility() {
      var anyOpen = document.querySelector('product-request-drawer[data-hidden="false"]');
      var badge = document.getElementById('shop-hcaptcha-badge-container');
      if (badge) {
        badge.style.display = anyOpen ? '' : 'none';
      }
    }
  }

  customElements.define('product-request-drawer', ProductRequestDrawer);
}
